import {ApiRes} from '@type/api'
import {apiPost} from '@api/api'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiCheckResetPasswordCode = async (email: string, code: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost(`password/reset/check`, {email: email, code: code})
}
